import { useLocation } from 'wouter-preact'
import { ROUTES } from '~/routes'
import styles from './TabBar.module.css'

/**
 * Bottom tab navigation (D-004).
 *
 * Uses real links so browser back/forward and long-press behave natively.
 * The active tab is marked with `aria-current`, and carries a visible text
 * label plus a non-colour indicator — state is never signalled by colour alone.
 */
export function TabBar() {
  const [location, navigate] = useLocation()

  return (
    <nav class={styles.tabBar} aria-label="Primary">
      <ul class={styles.list}>
        {ROUTES.map((route) => {
          const isActive = location === route.path
          return (
            <li key={route.path} class={styles.item}>
              <a
                href={`#${route.path}`}
                class={styles.link}
                aria-current={isActive ? 'page' : undefined}
                onClick={(event) => {
                  // Let modified clicks fall through to the browser.
                  if (event.metaKey || event.ctrlKey || event.shiftKey) return
                  event.preventDefault()
                  navigate(route.path)
                }}
              >
                <span aria-hidden="true" class={styles.indicator} />
                <span class={styles.label}>{route.label}</span>
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
